import React from 'react';
import s from '../style/modalStyle.module.scss';
import { Button } from '../../FormComponents/Button/Button';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { changeShowModal } from '../../../store/actions/SideMenu';

export const ModalAddSite = () => {

    const dispatch = useDispatch();
    const history = useHistory();

    const backToSitesPage = () => {
        history.push(`/sites`);
        dispatch(changeShowModal({ 'nameModal': "newSite", 'stateModal': false, otherParams: undefined }))
    }
    
    return (
        <div className={s.modalBox}>
            <div className={s.title}> Done!</div>
            <div className={s.description}>New Site was successfully published</div>
            <Button text="Back to Sites list" type="submit" class_type="secondary" onClick={() => backToSitesPage()} />
        </div>
    )
}
